var popover = require('bootstrap-sass/assets/javascripts/bootstrap/popover');
var component = require('../../../lib/js/component.js');

function PopoverBtn() {
    var isClickOpen = false;

    this.initialize = function (element, options) {
        var _this = this;

        this.$element = $(element);
        this.$element.attr("aria-expanded", false);
        this.$element.data("isClickOpen", false);
        // Delay required due to Bootstrap popover rendering timing issues,
        // ensures the DOM is fully ready before initializing popover.
        setTimeout(function(){
            initializePopover();
        },300);

        function initializePopover() {
            var placement = _this.$element.attr("data-placement") || "auto";

            _this.$element.popover({
                trigger: "manual",
                placement: placement,
                delay: { show: 50, hide: 400 },
                template: '<div class="popover" aria-label="tooltip" role="tooltip"><div class="arrow"></div><div class="popover-scroll-wrap"><h3 class="popover-title"></h3><div class="popover-content"></div></div></div>'
            });

            setupEventHandlers();
        }

        // Setup hover, click, and keyup event handlers
        function setupEventHandlers() {
            // Hover: Show popover on mouseenter (only if not manually opened by click)
            _this.$element.off("mouseenter.popoverBtn").on("mouseenter.popoverBtn", function () {
                if (!_this.$element.data("isClickOpen")) {
                    _this.$element.popover("show");
                    _this.$element.attr("aria-expanded", true);
                    _this.$element.removeAttr("aria-describedby");
                    setupCloseButton();
                }
            });

            // Hover: Hide popover when mouse leaves both button and popover
            _this.$element.off("mouseleave.popoverBtn").on("mouseleave.popoverBtn", function () {
                if (!_this.$element.data("isClickOpen")) {
                    // Small delay to allow user to move from button to popover
                    setTimeout(function () {
                        var $popover = _this.$element.data("bs.popover").tip();
                        if ($popover && !$popover.is(":hover") && !_this.$element.data("isClickOpen")) {
                            closePopover();
                        }
                    }, 300);
                }
            });

            // Click: Force popover to open and lock it in 'click open' mode
            _this.$element.off("click.popoverBtn").on("click.popoverBtn", function (e) {
                e.preventDefault();
                if (!_this.$element.data("isClickOpen")) {
                    _this.$element.data("isClickOpen", true);
                    _this.$element.popover("show");
                    _this.$element.attr("aria-expanded", true);
                    _this.$element.removeAttr("aria-describedby");
                    setupCloseButton();

                    if (e.originalEvent.pointerId === -1) {
                        focusPopoverCloseBtn();
                        setupPopoverOnTabEnter();
                    }
                }
            });

            // When popover hides, reset state
            _this.$element.off("hidden.bs.popover").on("hidden.bs.popover", function () {
                if (!_this.$element.data("isClickOpen")) {
                    _this.$element.attr("aria-expanded", false);
                } else {
                    // Reopen if it was manually clicked open (persist on mobile scroll)
                    _this.$element.popover("show");
                    _this.$element.attr("aria-expanded", true);
                    _this.$element.removeAttr("aria-describedby");
                    setupCloseButton(); // ensure close button still works
                }
            });

        }

        function setupCloseButton() {
            // setTimeout ensures popover DOM is injected before trying to find .popover-close-btn
            setTimeout(function () {
                var $popover = _this.$element.data("bs.popover").tip();
                if ($popover && $popover.length) {
                    var $closeBtn = $popover.find(".popover-close-btn");
                    $closeBtn.off("click.popoverCloseBtn").on("click.popoverCloseBtn", function (e) {
                        e.preventDefault();
                        closePopover();
                        _this.$element.trigger("focus");
                    });
                }
            }, 100);
        }

        function focusPopoverCloseBtn() {
            var $popover = _this.$element.data("bs.popover").tip();
            if ($popover) {
                var $closeBtn = $popover.find(".popover-close-btn");
                if ($closeBtn.length) {
                    $closeBtn.trigger("focus");
                }
            }
        }

        function setupPopoverOnTabEnter() {
            var $popover = _this.$element.data("bs.popover").tip();
            if ($popover) {
                $popover.off("keydown.popoverTab").on("keydown.popoverTab", function (event) {
                    if (event.key === "Tab") { // Check if the pressed key is Tab
                        event.preventDefault(); // Stop the default action
                    }
                });
            }
        }

        // Close the popover completely and reset state
        function closePopover() {
            _this.$element.popover("hide");
            _this.$element.attr("aria-expanded", false);
            _this.$element.data("isClickOpen", false);
        }
    };
}

/* ---------------- GLOBAL HANDLERS ---------------- */

// Close all when Escape pressed
$(document).off("keyup.popoverGlobal").on("keyup.popoverGlobal", function (e) {
    if (e.key === "Escape") {
        $(".PopoverBtn").each(function () {
            var $btn = $(this);
            if ($btn.data("isClickOpen")) {
                $btn.popover("hide");
                $btn.attr("aria-expanded", false);
                $btn.data("isClickOpen", false);
            }
        });
    }
});

// Custom event: close all popovers at once
$(document).off("closeAllPopovers").on("closeAllPopovers", function () {
    $(".PopoverBtn").each(function () {
        var $btn = $(this);
        if ($btn.data("isClickOpen")) {
            $btn.popover("hide");
            $btn.attr("aria-expanded", false);
            $btn.data("isClickOpen", false);
        }
    });
});

var lastWidth = window.innerWidth;

$(window).off("resize.popoverFix").on("resize.popoverFix", function () {
   // On mobile, scrolling hides/shows the URL bar, changing viewport height.  
   // Ignore those resizes — close popovers only when width changes.
    if (window.innerWidth !== lastWidth) {
        $(document).trigger("closeAllPopovers");
        setTimeout(function() { lastWidth = window.innerWidth; }, 300)
    }
});

module.exports = component(PopoverBtn);
 